var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#01A96E",
  fillRule: "evenodd",
  d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m.583 2.2H6.417v5.361l.009.104c.024.135.096.259.204.347l3.111 2.55.74-.902-2.898-2.375z"
})));
export { SvgIconClock as ReactComponent };
export default __webpack_public_path__ + "img/icon-clock.5115ce9e05fe368e756d77211563af6f.svg";